import React from "react";
const IconBirthday = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden {...props}>
    <path
      d="M3 13V18H17V13M3 13V9H10M3 13C4 13.5 5 13.5 6 13C7.5 12.25 8.5 12.25 10 13C11.5 13.75 12.5 13.75 14 13C15 12.5 16 12.5 17 13M17 13V9H10M10 9V6M10 6C8 6 8.50005 4.5 9 3.5C9.49995 2.5 10 2 10 2C10 2 10.5 2.5 11.0001 3.5C11.5001 4.5 12 6 10 6Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
  </svg>
);
export default IconBirthday;
